import React from 'react';
import Link from 'next/link';
import { ArrowUp, ArrowDown, Minus } from 'lucide-react';
import { USERS, getRankMovement } from '@/lib/mockData';

const movers = [...USERS]?.sort((a, b) => Math.abs(b?.previousRank - b?.rank) - Math.abs(a?.previousRank - a?.rank))?.slice(0, 6);

export default function BiggestMovers() {
  return (
    <div>
      <div className="flex items-center gap-3 mb-5">
        <div className="p-2 rounded-lg" style={{ background: 'rgba(34, 197, 94, 0.1)' }}>
          <ArrowUp size={18} style={{ color: 'var(--primary)' }} />
        </div>
        <div>
          <h2 className="text-lg font-bold" style={{ color: 'var(--foreground)' }}>
            Biggest Movers
          </h2>
          <p className="text-xs" style={{ color: 'var(--muted-foreground)' }}>
            Rank changes this week
          </p>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 xl:grid-cols-6 2xl:grid-cols-6 gap-3">
        {movers?.map((user) => {
          const movement = getRankMovement(user);
          const isUp = movement?.direction === 'up';
          const isDown = movement?.direction === 'down';

          return (
            <Link
              href="/leaderboard"
              key={`mover-${user?.id}`}
              className="flex flex-col items-center text-center p-4 rounded-xl transition-all duration-200 hover:scale-[1.03] group"
              style={{
                background: 'var(--muted)',
                border: '1px solid var(--border)',
              }}
            >
              {/* Avatar */}
              <div
                className="w-12 h-12 rounded-full flex items-center justify-center text-sm font-bold mb-2 transition-all duration-200"
                style={{
                  background: user?.avatarColor,
                  color: '#fff',
                  boxShadow: `0 0 0 2px ${isUp ? 'var(--primary)' : isDown ? '#ef4444' : 'var(--border)'}`,
                }}
              >
                {user?.initials}
              </div>
              <p className="text-xs font-bold truncate w-full" style={{ color: 'var(--foreground)' }}>
                {user?.displayName?.split(' ')?.[0]}
              </p>
              <p className="text-xs" style={{ color: 'var(--muted-foreground)' }}>
                #{user?.rank}
              </p>
              {/* Movement badge */}
              <div
                className="flex items-center gap-0.5 mt-2 px-2 py-0.5 rounded-full text-xs font-bold"
                style={{
                  background: isUp ? 'rgba(34,197,94,0.12)' : isDown ? 'rgba(239,68,68,0.12)' : 'rgba(107,114,128,0.1)',
                  color: isUp ? 'var(--primary)' : isDown ? '#ef4444' : 'var(--muted-foreground)',
                }}
              >
                {isUp ? <ArrowUp size={10} /> : isDown ? <ArrowDown size={10} /> : <Minus size={10} />}
                {movement?.delta > 0 ? movement?.delta : '—'}
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}